export interface HeadSeo {
  title: string;
  description: string;
  keywords: string;
  robots: string;
  canonical: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogType: string;
  ogImage?: string;
  articlePublishedTime?: string;
  twitterCard: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  const selector = attr === 'property' ? `meta[property="${key}"]` : `meta[name="${key}"]`;
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr: 'name' | 'property', key: string) {
  const selector = attr === 'property' ? `meta[property="${key}"]` : `meta[name="${key}"]`;
  document.querySelectorAll(selector).forEach((el) => el.remove());
}

// Applies resolved route SEO to <head>. Optional tags are reset first so
// metadata from a previous route never leaks into the current one.
export function applyHead(seo: HeadSeo) {
  document.title = seo.title;

  removeMeta('property', 'og:image');
  removeMeta('property', 'article:published_time');
  removeMeta('name', 'twitter:image');

  upsertMeta('name', 'description', seo.description);
  upsertMeta('name', 'keywords', seo.keywords);
  upsertMeta('name', 'robots', seo.robots);

  upsertMeta('property', 'og:title', seo.ogTitle);
  upsertMeta('property', 'og:description', seo.ogDescription);
  upsertMeta('property', 'og:url', seo.ogUrl);
  upsertMeta('property', 'og:type', seo.ogType);

  upsertMeta('name', 'twitter:card', seo.twitterCard);
  upsertMeta('name', 'twitter:title', seo.twitterTitle);
  upsertMeta('name', 'twitter:description', seo.twitterDescription);

  let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', seo.canonical);

  if (seo.ogImage) upsertMeta('property', 'og:image', seo.ogImage);
  if (seo.articlePublishedTime) upsertMeta('property', 'article:published_time', seo.articlePublishedTime);
  if (seo.twitterImage) upsertMeta('name', 'twitter:image', seo.twitterImage);
}